<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw Dedication-rw" epub:type="frontmatter dedication" id="Dedication1">
<div class="block-rw dedication-rw" id="dedication1">
<p class="ded-rw" id="p21" style="text-align: center;"><span><span><i>For Carrington and Raleigh: Mommies are supposed to be the heroes. But instead, I was given two little heroes who inspire me every single day. I love you to pieces.</i></span></span></p>
</div>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// s003-Dedication-01.vue?e15aabfe